import { Skeleton } from '../../Skeleton/Skeleton';

export function ScrollableSectionLoader({ label }: { label: string }) {
  return (
    <div className="flex min-w-0 flex-1 items-center gap-4">
      <p className="text-2xs text-contentSecondary">{label}</p>
      <div className="flex gap-3 overflow-x-auto">
        {Array.from({ length: 8 }).map((_, index) => (
          <Skeleton className="h-4 w-24" key={index} />
        ))}
      </div>
    </div>
  );
}
